export default "__VITE_ASSET__Cu9FR9$h__"